var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
var sizes = {
    xs: { width: "14", height: "14" },
    sm: { width: "16", height: "16" },
    md: { width: "20", height: "20" },
    lg: { width: "24", height: "24" },
    xl: { width: "40", height: "40" },
};
export var Svg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n    ", "\n"], ["\n    width: ", "px;\n    height: ", "px;\n    ", "\n"])), function (props) { return props.width; }, function (props) { return props.height; }, function (props) { return (props.fillStyle ? props.fillStyle : ""); });
var BaseIcon = function (_a) {
    var size = _a.size, _b = _a.defaultSize, defaultSize = _b === void 0 ? sizes.lg : _b, _c = _a.viewBox, viewBox = _c === void 0 ? "0 0 24 24" : _c, fillColor = _a.fillColor, _d = _a.fillColorRule, fillColorRule = _d === void 0 ? "&&& path, &&& use, &&& g, &&& circle" : _d, children = _a.children, ariaLabel = _a.ariaLabel, ariaHidden = _a.ariaHidden, props = __rest(_a, ["size", "defaultSize", "viewBox", "fillColor", "fillColorRule", "children", "ariaLabel", "ariaHidden"]);
    var fillStyle = fillColor && fillColorRule ? "".concat(fillColorRule, "{ fill: ").concat(fillColor, "; }") : "";
    var _e = size && typeof size === "object" && "width" in size && "height" in size
        ? size
        : typeof size === "string"
            ? sizes[size] || defaultSize
            : defaultSize, width = _e.width, height = _e.height;
    return (_jsx(Svg, __assign({ role: "img", width: width, height: height, viewBox: viewBox, fillStyle: fillStyle, "aria-label": ariaLabel, "aria-hidden": ariaHidden !== undefined ? String(ariaHidden) : true }, props, { children: children })));
};
export default BaseIcon;
var templateObject_1;
